//Show colors if tarro selected
let tarroOption = document.querySelector('.product__info-wrapper .product-form__input [value*="Tarro"]');
let presentationOptions = document.querySelectorAll('.product__info-wrapper .product-form__input [name="Presentación"] ');
let colorOption = document.querySelector('.product__info-wrapper .product-form__input [name="Color"]');
let defaultColorOption = document.querySelector('.product__info-wrapper .product-form__input [name="Color"][value="Default"]');
if (tarroOption !== null) {
  isTarroSelected();

  presentationOptions.forEach((option) => {
    option.addEventListener("change", () => {
      isTarroSelected();
    })
  })

  function isTarroSelected() {
    if (tarroOption.checked) {
      colorOption.parentElement.classList.remove("hide-color")
      colorOption.parentElement.classList.add("show-color");
    } else {
      colorOption.parentElement.classList.remove("show-color");
      colorOption.parentElement.classList.add("hide-color");
      defaultColorOption.checked=true;
    }
  }
}

//Change color scheme header & foooer
let header = document.querySelector(".not-home .header-wrapper");
let footer = document.querySelector(".not-home .footer ");
let homeHeader = document.querySelector(".home  .header-wrapper");
let homeFooter = document.querySelector(".home .footer");
let schemeHome ="color-scheme-40d85edf-b647-4e28-82cd-8325c8844de0";
let firstColorSchemeFound = document.querySelector('.not-home #MainContent [class*="color-scheme-"]');
let h1NotScheme = document.querySelector(".not-home  h1");

if ( homeHeader !== null || firstColorSchemeFound !== null || h1NotScheme !== null) {
  let classScheme;

  if (homeHeader !== null) {
    classToReplace(homeHeader, schemeHome);
    classToReplace(homeFooter, schemeHome);    
  }

  if (firstColorSchemeFound !== null && homeHeader  === null) {
    searchSchemeClss(firstColorSchemeFound)
    classToReplace(header, classScheme);
    classToReplace(footer, classScheme)
    
  }

  if (h1NotScheme !== null && firstColorSchemeFound === null) {
    const computedStyle = getComputedStyle(h1NotScheme);
    const h1Color = computedStyle.color;

    header.style.backgroundColor = h1Color;
    footer.style.backgroundColor = h1Color;
}

  function classToReplace(element, classNameToReplaced) {
    element.classList.forEach((clase) => {
      if (clase.includes("color-scheme-")) {
        element.classList.replace(clase, classNameToReplaced)
      }
    })
  }
  
  function searchSchemeClss(element) {
    element.classList.forEach((clase) => {
      if (clase.includes("color-scheme-")) {
        classScheme = clase;
      }
    })
  }
}


let imageWithText = document.querySelector(".section_image_with_text_product");

if (imageWithText !== null) {
  let elementsImageWithText = imageWithText.querySelectorAll(".image-with-text__heading, .image-with-text__text, .image-with-text__media-item, a.button--primary");
  console.log(elementsImageWithText);
  let allFilled = false;
  
  elementsImageWithText.forEach((el) => {
    
    if (el.classList.contains("image-with-text__heading")) {
        el.children > 0 ? allFilled = true : false;
      
    }
    
    if (el.classList.contains("image-with-text__text")) {
      el.children > 0 ? allFilled = true : false;
    }
    
    // Example operation: Change the background color of media items
    if (el.classList.contains("image-with-text__media-item")) {
      el.children > 0 ? allFilled = true : false;
    }
    
    // Example operation: Add an event listener to buttons
    if (el.classList.contains("button--primary")) {
       el.href ? true: false;
    }

    console.log(allFilled);
  });
}

// add produc into productRelatedWrapper
let productRelatedWrapper = document.querySelector('body[data-template="article"] .article-main-content-wrapper .product-related-wrapped');
let sectionFeaturedProudtcs = document.querySelectorAll('body[data-template="article"] .section-featured-product');

if (productRelatedWrapper !== null && sectionFeaturedProudtcs.length > 0) {
    
    sectionFeaturedProudtcs.forEach(section => {
        productRelatedWrapper.appendChild(section);
    })
}

// Show more fileter

let filterType = document.querySelectorAll(".disclosure-has-popup.filter_type");
let filterTypeMobile = document.querySelectorAll(".mobile-facets__details.filter_type");

if (filterType.length > 0 || filterTypeMobile.length > 0) {
  let isShowingAll = false;

  function iterateEveryUl(items, label) {
    if (items.length > 0) {
      items.forEach((item) => {
        let itemsLi = item.querySelectorAll("ul li");
        let toggleBtn = item.querySelector(".view-more");

        // Inicializar con los primeros 8 elementos visibles
        init(itemsLi, item, label);

        if (toggleBtn && !toggleBtn.classList.contains('initialized')) {
          toggleBtn.addEventListener("click", (e) => {
            e.preventDefault();
            toggleItems(itemsLi, e.target, label);
          });
          toggleBtn.classList.add('initialized');
        }
      });
    }
  }

  iterateEveryUl(filterType, ".facets__label.facet-checkbox.active");
  iterateEveryUl(filterTypeMobile, ".facets__label.mobile-facets__label.active");

  function toggleItems(items, toggleButton, label) {
    if (items !== undefined) {
      if (!isShowingAll) {
        // Mostrar todos los elementos
        toggleButton.textContent = "Ver menos";
        items.forEach(item => item.classList.add('show-all'));
      } else {
        // Ocultar y volver a inicializar
        items.forEach(item => item.classList.remove('show-all'));
        init(items, null, label);
        toggleButton.textContent = "Ver más";
      }
      isShowingAll = !isShowingAll; // Cambiar estado
    }
  }

  function init(items, parentItems, label) {
    let visibleCount = 0;
    let activeItems = [];

    // Mostrar siempre los elementos activos
    items.forEach((item) => {
      if (item.querySelector(label)) {
        item.classList.add('visible'); // Agregar visible a activos
        activeItems.push(item); // Almacenar los elementos activos
      } else {
        item.classList.remove('visible'); // Asegurar que inactivos no tengan visible
      }
    });

    // Contar cuántos activos hay para gestionar el límite de 8
    visibleCount = activeItems.length;

    // Si todos los elementos son activos, limitar a 8
    if (visibleCount === items.length) {
      items.forEach((item, index) => {
        if (index >= 8) {
          item.classList.remove('visible'); // Ocultar los elementos extra
        }
      });
    } else {
      // Mostrar elementos inactivos hasta alcanzar un total de 8 visibles
      items.forEach((item) => {
        if (!item.classList.contains('visible') && visibleCount < 8) {
          item.classList.add('visible');
          visibleCount++;
        }
      });
    }

    // Si hay más de 8 elementos, añadir la clase "has-more" al contenedor padre
    if (parentItems && items.length > 8) {
      parentItems.classList.add("has-more");
    }

    // Asegurar que no se muestren más de 8
    if (!isShowingAll) {
      items.forEach((item) => {
        if (!item.classList.contains('visible')) {
          item.classList.remove('visible');
        }
      });
    }
  }

  const targetNode = document.body;
  const config = { childList: true, subtree: true };

  const callback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        iterateEveryUl(filterType, ".facets__label.facet-checkbox.active");
        iterateEveryUl(filterTypeMobile, ".facets__label.mobile-facets__label.active");
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}


/*
//Add libraries select
 new SlimSelect({
    select: 'select',
    showSearch: false,
    openPosition: 'down'
});
*/







